import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { highlightedText } from './scss/HighlightedText.module.scss';

const HighlightedText = ({ value, className }) => {
  const computedClassNames = classNames(highlightedText, className);
  return <span className={computedClassNames}>{value}</span>;
};

HighlightedText.propTypes = {
  value: PropTypes.string.isRequired,
};

export default HighlightedText;
